import { store } from "react-notifications-component";

export const SUCCESS = "success";
export const DANGER = "danger";
export const ERROR = "Error";


export const ACH_ENABLED_MESSAGE = "ACH option has been successfully enabled";
export const CC_ENABLED_MESSAGE = "CC option has been successfully enabled";

export const ACH_DISABLED_MESSAGE = "ACH option has been successfully disabled";
export const CC_DISABLED_MESSAGE = "CC option has been successfully disabled";

export const INTERNAL_SERVER_ERROR = "Internal Server Error";
export const DATA_SAVED = "Company Information saved successfully.";
export const SAVE_ERROR = "Your changes could not be saved. Please try again.";
export const SAVE_IMG_ERROR = "Please upload the image in proper format";
export const INVALID_IMG_SIZE = "Image file size exceeded. Please upload an image within 5MB.";
export const FETCH_ERROR = "Unable to fetch data, some error occurred while loading.";

export const APP_SELECT_ERROR = "You are not an administrator for this agent";
export default class ReactNotification {
    public static showNotification(title: string, message: string, type: any): void {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true
            }
        });
    }
}

export {
    ReactNotification as Notification
}